// Utils
import useSocialProfilesAuthStatus from '@/utils/hooks/swr/useSocialProfilesAuthStatus';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

import { MultiSelectionProfiles } from '@/components/composite/SelectedProfiles/MultiSelectionProfiles';
// Components
import { ProfilesList } from '@/components/composite/SelectedProfiles/ProfilesList';

export type SelectedProfilesProps = {
    itemsSize?: 'base' | 'md';
};

function SelectedProfiles({ itemsSize = 'base' }: SelectedProfilesProps) {
    useSocialProfilesAuthStatus();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeSocialProfileId, activeMultiSelectionProfiles, activeGroupId } = useProfilesStore(
        (state) => state
    );

    if (activeGroupId || activeMultiSelectionProfiles?.socialProfileIds) {
        return <MultiSelectionProfiles itemsSize={itemsSize} />;
    }

    if (activeSocialProfileId) {
        return <ProfilesList itemsSize={itemsSize} profiles={[activeSocialProfile]} />;
    }

    return null;
}

export default SelectedProfiles;
